import React from 'react';

export function TypeColumnFormatter(cellContent) {
  const {customerType, customerTypeName} = cellContent;

  switch (customerType) {
    case 1:
      return (
        <div
          className="badge badge-pill w-100px font-size-h4 text-nowrap"
          style={{
            background: '#E3F0FB',
            border: '1px solid rgb(56, 189, 248)',
            color: 'rgb(56, 189, 248)'
          }}
        >
          {customerTypeName}
        </div>
      );
    case 2:
      return (
        <div
          className="badge badge-pill w-100px font-size-h4 text-nowrap"
          style={{
            background: '#F9F4E5',
            border: '1px solid rgb(253, 185, 19)',
            color: 'rgb(253, 185, 19)'
          }}
        >
          {customerTypeName}
        </div>
      );
    case 3:
      return (
        <div
          className="badge badge-pill w-100px font-size-h4 text-nowrap"
          style={{
            background: '#CDEADB',
            border: '1px solid rgb(65, 141, 88)',
            color: 'rgb(65, 141, 88)'
          }}
        >
          {customerTypeName}
        </div>
      );
    case 4:
      return (
        <div
          className="badge badge-pill w-100px font-size-h4 text-nowrap"
          style={{
            background: 'rgb(233, 236, 236)',
            border: '1px solid rgb(82, 94, 96)',
            color: 'rgb(82, 94, 96)'
          }}
        >
          {customerTypeName}
        </div>
      );
    case 5:
      return (
        <div
          className="badge badge-pill w-100px font-size-h4 text-nowrap"
          style={{
            background: '#F2E6E6',
            border: '1px solid rgb(239, 65, 48)',
            color: 'rgb(239, 65, 48)',
          }}
        >
          {customerTypeName}
        </div>
      );
    default:
      return null;
  }
}